export default __webpack_public_path__ + "static/media/150cc2.238f41e3.jpg";